import { Configuration } from '.'
import { getAuthService } from '../services/authService'

export const getConfiguration = async (): Promise<Configuration> => {
  const authService = await getAuthService()
  const accessToken = await authService.getAccessToken()

  const config = new Configuration({
    basePath: import.meta.env.VITE_BASE_URL || '',
    accessToken: accessToken ?? undefined,
    middleware: [
      {
        post: async (context) => {
          const e = context.response
          if (e.status === 401) {
            const authService = await getAuthService()
            authService.logout()
          }
        }
      }
    ]
  })
  return config
}